export default __webpack_public_path__ + "static/media/arrow_tip_dark.9dceb538.svg";